import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import { legalNavigation, footerNavigation } from "../data/siteNavigation";
import { socialLinks } from "../data/socialLinks";
import { components, typography } from "../styles/designSystem";

const Footer = () => (
  <footer className="relative overflow-hidden bg-secondary pt-16 pb-8">
    {/* Decorative shapes */}
    <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary/[0.10] blur-3xl" />
    <div className="pointer-events-none absolute -left-12 bottom-8 h-40 w-40 rotate-12 rounded-[3rem] bg-accent/[0.08]" />
    <div className="pointer-events-none absolute right-[15%] top-10 h-4 w-4 rounded-full bg-accent/30" />
    <div className="pointer-events-none absolute left-[20%] top-6 h-6 w-6 rounded-full border-[3px] border-white/10" />

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* Top section: logo, nav, social */}
      <div className="grid gap-10 md:grid-cols-[1.2fr,1fr,auto] md:gap-12 pb-10 border-b border-white/10">
        {/* Brand */}
        <div className="space-y-4">
          <Link to="/" aria-label="Go to homepage">
            <img
              src="/images/brand/o3s-logo.png"
              alt="O3S logo"
              className="h-16 w-auto brightness-0 invert opacity-90"
            />
          </Link>
          <p className={`${typography.body.small} text-white/60 max-w-xs`}>
            Strategy, design, development and growth in one place, tailored for
            small businesses that want clarity.
          </p>
        </div>

        {/* Navigation */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-3">
          <div>
            <p
              className={`${typography.label} text-white/40 mb-4 tracking-widest`}
            >
              Pages
            </p>
            <ul className="space-y-2.5">
              {footerNavigation.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className={`${typography.body.small} text-white/70 hover:text-white transition-colors duration-200`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p
              className={`${typography.label} text-white/40 mb-4 tracking-widest`}
            >
              Legal
            </p>
            <ul className="space-y-2.5">
              {legalNavigation.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className={`${typography.body.small} text-white/70 hover:text-white transition-colors duration-200`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Social + CTA */}
        <div className="space-y-6">
          <div>
            <p
              className={`${typography.label} text-white/40 mb-4 tracking-widest`}
            >
              Connect
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                  className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/15 bg-white/[0.06] text-white/70 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary/50 hover:bg-primary hover:text-white"
                >
                  <social.Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <Link
            to="/contact"
            className={`${components.button.small} bg-primary/20 border border-primary/30 hover:bg-primary mx-auto mt-8`}
          >
            Start a project
            <FiArrowUpRight className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="flex flex-col items-center justify-between gap-4 pt-8 md:flex-row">
        <p className="text-xs text-white/50">
          &copy; {new Date().getFullYear()} O3S. All rights reserved.
        </p>
        <p className="text-xs text-white/40">
          Built with care in Germany & Indonesia.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
